import { Link } from "react-router-dom";
import { softwareList } from "@/mocks/software";
import { categories } from "@/mocks/categories";

export default function SiteIntro() {
  const stats = [
    { icon: "ri-apps-2-line", value: `${softwareList.length}+`, label: "收录中文软件" },
    { icon: "ri-folder-3-line", value: `${categories.length}`, label: "软件分类" },
    { icon: "ri-refresh-line", value: "每日", label: "更新版本资讯" },
    { icon: "ri-user-smile-line", value: "数十万", label: "用户信赖" },
  ];

  return (
    <section className="w-full max-w-[1240px] mx-auto px-4 md:px-6 pt-14 md:pt-16">
      <div className="bg-background-100 rounded-lg border border-background-200 p-6 md:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs text-primary-700 bg-primary-100 rounded-full px-3 py-1">
              <span className="flex items-center justify-center w-4 h-4"><i className="ri-information-line" aria-hidden="true"></i></span>
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
              专注中文手机软件的资源与版本资讯平台
            </h2>
            <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
              最近最新手机中文大全10 面向安卓与 iOS 手机用户，聚焦中文应用合集与最新版本下载资讯。我们按社交、工具、游戏、生活等场景进行专业分类，提供清晰的软件介绍、版本更新历史与相关推荐，帮助新手和资深用户都能高效找到所需应用。
            </p>
            <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
              网站内容持续更新，力求覆盖最新版本与真实使用信息，让查找与了解软件变得更简单。
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-2 h-10 px-5 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
              <span className="flex items-center justify-center w-4 h-4"><i className="ri-arrow-right-line" aria-hidden="true"></i></span>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="bg-background-50 rounded-lg border border-background-200 p-5">
                <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent-100 text-accent-600 text-xl">
                  <i className={s.icon} aria-hidden="true"></i>
                </span>
                <p className="mt-3 font-heading text-xl font-bold text-foreground-950">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}